import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('card-add-to-cart')) {

  async function fetchCart() {
    const cartItems = document.querySelector('cart-items-component');
    if (cartItems) {
      await customElements.whenDefined('cart-items-component');
      if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
    }
    const response = await fetch(`${Theme.routes.cart_url}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    return response.json();
  }

  class CardAddToCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button[data-variant-id]');
      if (!this.button || this.button.dataset.bound) return;
      this.button.dataset.bound = 'true';
      this.button.addEventListener('click', (event) => this.add(event));
    }

    async add(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.button.disabled) return;

      const variantId = this.button.dataset.variantId;
      const label = this.querySelector('[data-label]');
      const live = this.querySelector('[data-live]');
      const originalText = label.textContent;
      const addedText = this.dataset.added || 'Added!';
      const errorText = this.dataset.error || 'Could not add to cart';
      this.button.disabled = true;
      this.button.classList.add('is-loading');

      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      promise.catch(() => {});

      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise,
        })
      );

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        const result = await response.json();
        const failed = !response.ok || result.status;
        const cart = await fetchCart();

        resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'card-add-to-cart',
            sourceId: variantId,
            itemCount: 1,
            productId: this.button.dataset.productId,
            didError: Boolean(failed),
          },
        });

        const message = failed ? result.description || result.message || errorText : addedText;
        label.textContent = message;
        if (live) live.textContent = message;
      } catch (error) {
        reject(error);
        label.textContent = errorText;
        if (live) live.textContent = errorText;
      }

      this.button.classList.remove('is-loading');
      setTimeout(() => {
        label.textContent = originalText;
        if (live) live.textContent = '';
        this.button.disabled = false;
      }, 2000);
    }
  }

  customElements.define('card-add-to-cart', CardAddToCart);
}
